import cn from 'classnames'

import { TransactionIcon } from 'src/components/ui'

import styles from './TransactionDetail.module.scss'

interface Props {
  className?: string

  iconName: string
  label: string
  title: string
}

export const TransactionDetail: React.FC<Props> = ({ className, iconName, label, title }) => {
  return (
    <div className={cn(className, styles.detail)}>
      <TransactionIcon name={iconName} />
      <div>
        <p className={styles.label}>{label}</p>
        <p className={styles.title}>{title}</p>
      </div>
    </div>
  )
}
